import React, { useState } from 'react'
import './LandingPage.css'
import { Link, useNavigate } from "react-router-dom";
import { signUp } from "../../services/auth/auth";
import { AiFillMail } from "react-icons/ai";
import { RiLockPasswordFill } from "react-icons/ri";
import { BsTelephoneFill } from "react-icons/bs";
import { IoIosContact } from "react-icons/io";
import { IconContext } from "react-icons";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FcGoogle } from 'react-icons/fc';
const LandingPageSignUp = (props) => {
  console.log('data of props :',props)
  let { SignUpModal, setSignUpModal } = props
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      confirmPassword: "",
      phoneNumber: "",
      password: "",
    },
    onSubmit: values => {
      setLoader(true);
      signUp(values)
        .then((res) => {
          console.log("res :", res);
          toast.success("Verification Email Sent To Your Email ", {
            theme: "colored",
          });
          // navigate("/landingPage");
          setSignUpModal(false)
          setLoader(false);
        })
        .catch((e) => {
          console.error(e);
          setLoader(false);
          toast.error("something went wrong", {
            theme: "colored",
          });
        });
    },
    validate: values => {
      let errors = {}
      if (!values.name) {
        errors.name = "Name Required"
      }
      if (!values.email) {
        errors.email = "Email Required"

      } else if (!/^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = "Invalid email format"
      }
      if (!values.confirmPassword) {
        errors.confirmPassword = "Confirm Password Required"
      }
      if (!values.phoneNumber) {
        errors.phoneNumber = "Phone Number Required"
      }
      if (!values.password) {
        errors.password = "Password Required"
      }
      if (values.password !== values.confirmPassword){
        errors.confirmPassword = "password and confirm password must be same"
      }
      return errors

    }
  })

  return (
    <div className='containerdivmodalsign p-2'>
      <form onSubmit={formik.handleSubmit} style={{marginTop:-60}}>
        <h3 className="signup-register-heading pb-4 ">Register</h3>
        <div className="input-main" >
          <div>
            <input
              className="input__fields p-1"
              type="text"
              placeholder="Enter Name"
              id="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />

            {formik.touched.name && formik.errors.name ? <div className="s">{formik.errors.name}</div> : null}

          </div>

          <div>

            <input
              className="input__fields p-1"
              type="email"
              id="email"
              placeholder="Enter Email "
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />

            {formik.touched.email && formik.errors.email ? <div className="s">{formik.errors.email}</div> : null}
          </div>
          <div>

            <input
              className="input__fields p-1"
              type="text"
              id="phoneNumber"
              placeholder="Enter phone Number"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />

            {formik.touched.phoneNumber && formik.errors.phoneNumber ? <div className="s">{formik.errors.phoneNumber}</div> : null}
          </div>
          <div>

            <input
              className="input__fields p-1"
              type="Password"
              id="password"
              placeholder="Enter Password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />

            {formik.touched.password && formik.errors.password ? <div className="s">{formik.errors.password}</div> : null}
          </div>
          <div>
            <input
              className="input__fields p-1"
              type="password"
              id="confirmPassword"
              placeholder="Enter the Confirm password"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.confirmPassword && formik.errors.confirmPassword ? <div className="s">{formik.errors.confirmPassword}</div> : null}
          </div>
        </div>
        <button className='btngoogdivsignup' style={{ border: "none", outline: "none" }}
        >SignUp</button>
        <div className='anacountsing'>
          <span style={{ color: 'black' }} class="psw">Already have an account <a href="#">Sign In</a></span>
        </div>
      </form>
    </div>
  )
}

export default LandingPageSignUp
